import React, { useEffect, useState } from "react";
import SectionTitle from "../../Components/SectionTitle";
import { Card, Image } from "antd";
import { getPaymentMethods } from "./action";
import { IBettingWebsitePaymentGatway } from "../../types/BettingWebsite.PaymentGateway";
import { PAYMENT_METHOND_CLOUD_URL } from "../../lib/env";

type Props = {};

const PaymentMethods = (props: Props) => {
  const [data, setData] = useState<IBettingWebsitePaymentGatway[]>([]);

  const fetchData = async () => {
    const payment_methods = await getPaymentMethods();
    setData(payment_methods);
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div className="space-y-5">
      {" "}
      <SectionTitle title="Payment Methods" />
      <Card className=" shadow-md">
        <div className="grid grid-cols-4 gap-4">
          {data.map((dt) => (
            <Card
              style={{ width: 300 }}
              cover={
                <Image
                  className=" w-full aspect-video"
                  alt="example"
                  src={PAYMENT_METHOND_CLOUD_URL + dt.Logo}
                />
              }
              actions={[
                <span>{dt.PaymentGatwayName.En}</span>,
                <span>{dt.PaymentGatwayName.Ar}</span>,
                <span>{dt.PaymentGatwayName.Fr}</span>,
              ]}
            ></Card>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default PaymentMethods;
